import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {
  AwardItem,
  act_info,
  banner_item,
  LuckWheelPrizeItem,
  lucky_big_wheel_rank_info,
  lucky_big_wheel_records_item,
  lucky_wheels,
  luckyItem,
  rewardWindow,
} from './interface'

// 主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92442802
export const lucky_big_wheel_config = createAsyncThunk(
  'lucky_big_wheel_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'lucky_wheels'
          | 'is_first'
          | 'balance'
          | 'award_list'
          | 'is_show_lucky_guide'
          | 'act_info'
          | 'err_msg'
        >
      >
    >(
      '/live/ground/ly_bw_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 幸运大转盘抽奖 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92442623
export const lucky_big_wheel_bet = createAsyncThunk(
  'lucky_big_wheel_bet',
  async (
    arg: {wheel_type: number; amount_type: number; room_id?: number},
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'lucky_big_wheel_prize_list'
          | 'status'
          | 'reward_window'
          | 'err_msg'
          | 'lucky_value'
          | 'user_ratio'
          | 'is_get_necessary_gift'
          | 'is_get_pre_necessary_gift'
          | 'lucky_item'
        >
      >
    >(
      '/live/ground/ly_bw_bet',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 幸运大转盘抽奖记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92442658
export const lucky_big_wheel_record = createAsyncThunk(
  'lucky_big_wheel_record',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'lucky_big_wheel_records'>>
    >('/live/ground/ly_bw_record', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 幸运大转盘活动banner http://wiki.xunlei.cn/pages/viewpage.action?pageId=96440123
export const lucky_big_wheel_banner_list = createAsyncThunk(
  'lucky_big_wheel_banner_list',
  // 1 是幸运转盘
  async (arg: {game_type: 1}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'banner_list'>>
    >('/live/ground/banner_list', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
interface InitialStateType {
  // 主页数据
  err_msg?: string
  lucky_wheels?: Array<lucky_wheels>
  is_first?: boolean
  // 是否展示幸运值引导
  is_show_lucky_guide?: boolean
  balance?: number
  award_list?: Array<AwardItem>
  // 抽奖信息
  status?: 0 | 1 | 2 // 0余额不足 1、成功 2 配置有问题
  lucky_big_wheel_prize_list?: Array<LuckWheelPrizeItem>
  reward_window?: rewardWindow
  is_get_necessary_gift?: boolean
  is_get_pre_necessary_gift?: boolean
  // 0 亏损， 1盈利
  user_ratio?: 0 | 1
  // 本次抽奖的幸运值
  lucky_value?: number
  // 排行榜
  rank_list?: Array<lucky_big_wheel_rank_info>
  my_rank_info?: lucky_big_wheel_rank_info
  lucky_big_wheel_records?: Array<lucky_big_wheel_records_item>
  // 本轮抽奖的item
  lucky_item?: luckyItem
  // 活动相关banner
  banner_list?: banner_item[]
  act_info?: act_info
  // loadingpage
  loadingPage: boolean
}

const initialState: InitialStateType = {
  loadingPage: true,
}

export const LuckyBigWheelSlice = createSlice({
  name: 'LuckyBigWheel',
  initialState,
  reducers: {
    changeLoadingPage: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        loadingPage: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(lucky_big_wheel_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(lucky_big_wheel_banner_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default LuckyBigWheelSlice.reducer
export const LuckyBigWheelActions = LuckyBigWheelSlice.actions
